<template>
    <div class="hundred_percent_form" v-loading="loading">
        <tinymce
            style="display: inline-block;width: 100%;"
            ref="tinymce"
            :height="500"
            v-model="form.configstext"
        />
        <div style="margin-top:20px">
            <el-button type="primary" @click="formSubmit" :loading="formLoading" >保 存</el-button>
            <el-button @click="onCancel">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import { introduct, editintroduce } from "../../api/setting/text.js";
    import Tinymce from "../../components/Tinymce/index.vue";
    export default {
        data() {
            return {
                loading: true,
                formLoading: false,
                form: {
                    configsid:"",
                    configstext: "",
                    configstype: 2
                }
            };
        },
        components: {
            Tinymce
        },
        methods: {
            onCancel() {
                this.getInfo();
            },
            getInfo() {
                this.loading = true;
                introduct({ configstype: this.form.configstype })
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (response.data) {
                            this.form = response.data;
                            this.$refs.tinymce.setContent(this.form.configstext);
                        }
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {});
            },
            formSubmit() {
                console.log(this.form)
                this.formLoading = true;
                let data = Object.assign({}, this.form);
                editintroduce(data).then(response => {
                    this.formLoading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    //刷新表单
                    this.getInfo();
                });
            }
        },
        created() {
            // 加载版本数据
            this.getInfo();
        }
    };
</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
</style>
